import React, { useState } from "react";
import { Formik } from 'formik';
import { Link, useNavigate} from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth"
import FullPageLoader from '../../../utils/loader';
import * as yup from 'yup';

import {auth} from "../../../firebase.config";

const Login = () => {
  const navigate = useNavigate(); 
  const [loginFail, setLoginFail] = useState(false);
  const [isLoading,setLoading] = useState(false);

 
  
  const signIn = async (email, password) => {
    try {
      setLoading(true)
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      const payload = {email: user.email,  name: user.email.split('@')[0].split(".")[0],token: user.stsTokenManager}
      localStorage.setItem("able-auctions",JSON.stringify(payload));
      setLoading(false)
      navigate("/");
      return true
    } catch (error) {
      setLoading(false)
      const errorCode = error.code;
      if( errorCode === 'auth/invalid-credential' || errorCode === 'auth/invalid-email' ) {
       setLoginFail(true)
      } 
    }
  };

  const validationSchema = yup.object({
    email: yup.string().email('Please enter a valid email address').required('Email is required'),
    password: yup.string().required('Password is required').min(6),
  });
  return (
      <div className="container forms-wrapper"> 
       { isLoading  &&    <FullPageLoader/> }
       {
          loginFail &&
          (
            <div className="alert alert-danger" style={{  position:"absolute",zIndex: 1,right: 0 }} role="alert">
              <p className="mb-0">Email or password is incorrect</p>
            </div>
          )
        }
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card o-hidden border-0 shadow-lg my-5">
              <div className="card-body p-0">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="p-5">
                      <div className="text-center">
                        <h1 className="h4 text-gray-900 mb-4">Welcome Back!</h1>
                      </div>
                      <Formik
                        initialValues={{ email: '', password: '' }}
                        validationSchema={validationSchema}
                        onSubmit={(values) =>  signIn(values.email, values.password) }
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                          /* and other goodies */
                        }) => (
                          <form  className="user" onSubmit={handleSubmit}>
                            <div className="form-group">
                              <label>Email Address</label>
                            <input
                              type="text"
                              name="email"
                              onChange={handleChange}
                              placeholder="Enter Email"
                              onBlur={handleBlur}
                              value={values.email} className="form-control form-control-user"
                              onFocus={() => setLoginFail(false)}
                            />
                            <div className="validation-err">
                              {errors.email && touched.email && errors.email}
                            </div>
                            </div>
                            <div className="form-group">
                              <label>Password</label>
                            <input
                              type="password"
                              name="password"
                              placeholder="Enter password"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password} className="form-control form-control-user"
                              onFocus={() => setLoginFail(false)}
                            />
                            <div className="validation-err">
                              {errors.password && touched.password && errors.password}
                            </div>
                            </div>
                            <div className="form-group">
                            <button disabled={isLoading} className="btn btn-primary btn-user btn-block" type="submit" >
                              Submit
                            </button>
                            </div>
                          </form>
                        )}
                      </Formik>
                      <div className="text-center">
                        <Link to={'/forgotPassword'}>Forgot Password?</Link>
                      </div>
                      {/* <div className="text-center">
                      <Link to={'/signup'}>Create an Account!</Link>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Login;
